export const DEFAULT_USE_ELLIPSIS = false;
export const DEFAULT_NUMBER_OF_PAGES_SHOWN_INTO_NAVIGATION = 5;
